(function () {
  var root = document;

  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  var drawer = qs("[data-drawer]");
  var burger = qs("[data-burger]");
  if (burger && drawer) {
    burger.addEventListener("click", function () {
      drawer.classList.add("is-open");
      drawer.hidden = false;
      burger.setAttribute("aria-expanded", "true");
    });
    qsa("[data-drawer-close]", drawer).forEach(function (btn) {
      btn.addEventListener("click", function () {
        drawer.classList.remove("is-open");
        drawer.hidden = true;
        burger.setAttribute("aria-expanded", "false");
      });
    });
  }

  function closeShopMenu() {
    var nav = qs("[data-chb-nav]");
    if (!nav) return;
    var mega = qs("[data-nav-mega]", nav);
    var dim = qs("[data-nav-dim]", nav);
    if (mega) mega.hidden = true;
    if (dim) dim.hidden = true;
    qsa(".chb-nav-item.is-active", nav).forEach(function (btn) {
      btn.classList.remove("is-active");
      btn.setAttribute("aria-expanded", "false");
    });
  }


  qsa("[data-hero]").forEach(function (hero) {
    var slides = qsa("[data-slide]", hero);
    if (!slides.length) return;
    var index = 0;
    var count = qs("[data-hero-count]", hero);
    var timer;
    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) { slide.classList.toggle("is-on", n === index); });
      if (count) count.textContent = String(index + 1).padStart(2, "0") + "/" + String(slides.length).padStart(2, "0");
    }
    function play() {
      stop();
      timer = setInterval(function () { show(index + 1); }, 6500);
    }
    function stop() { if (timer) clearInterval(timer); }
    show(0);
    play();
    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", play);
    hero.addEventListener("focusin", stop);
    hero.addEventListener("focusout", play);
    var prev = qs("[data-hero-prev]", hero);
    var next = qs("[data-hero-next]", hero);
    if (prev) prev.addEventListener("click", function () { show(index - 1); });
    if (next) next.addEventListener("click", function () { show(index + 1); });
  });

  function esc(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function safeUrl(url) {
    if (typeof url !== "string" || !url) return "";
    if (url.indexOf("//") === 0) return "https:" + url;
    if (url.charAt(0) === "/" || url.indexOf("https://") === 0 || url.indexOf("http://") === 0) return url;
    return "";
  }

  function suggestUrl(query) {
    var base = (window.CHB && window.CHB.suggest) || "";
    if (!base || base.charAt(0) !== "/") base = "/search/suggest.json";
    return base + "?q=" + encodeURIComponent(query) +
      "&resources[type]=product,collection,article,page&resources[limit]=5&resources[options][unavailable_products]=last";
  }

  function resultLink(url, image, title, meta) {
    var href = safeUrl(url);
    var src = safeUrl(typeof image === "string" ? image : "");
    if (!href || !title) return "";
    return '<a href="' + esc(href) + '">' +
      (src ? '<img src="' + esc(src) + '" alt="">' : '<span></span>') +
      '<span>' + esc(title) + '</span><strong>' + esc(meta || "") + '</strong></a>';
  }

  function trendData(form) {
    var node = qs("[data-chb-trending]", form.parentNode);
    if (!node) return null;
    var data;
    try {
      data = JSON.parse(node.textContent || "");
    } catch (err) {
      return null;
    }
    if (!data || typeof data.heading !== "string" || !data.heading.trim() || !Array.isArray(data.terms)) return null;
    var terms = [];
    data.terms.forEach(function (term) {
      if (terms.length >= 5) return;
      if (!term || typeof term.query !== "string" || typeof term.label !== "string") return;
      var query = term.query.trim();
      var label = term.label.trim();
      if (!query || !label || query.length > 48) return;
      terms.push({ query: query, label: label });
    });
    if (!terms.length) return null;
    return {
      heading: data.heading.trim(),
      search: data.search,
      type: data.type,
      terms: terms
    };
  }

  function trendHref(data, query) {
    var base = typeof data.search === "string" && data.search.charAt(0) === "/" ? data.search : "/search";
    var type = typeof data.type === "string" && data.type ? data.type : "product,article,page,collection";
    return base + "?q=" + encodeURIComponent(query) + "&type=" + encodeURIComponent(type);
  }

  function renderTrend(panel, input, data) {
    var html = '<p class="predict-label chb-trend-heading">' + esc(data.heading) + "</p>";
    data.terms.forEach(function (term) {
      html += '<a class="chb-trend" href="' + esc(trendHref(data, term.query)) + '">' + esc(term.label) + "</a>";
    });
    var shortcuts = panel.parentNode.querySelector("[data-search-shortcuts]");
    panel.innerHTML = html + (shortcuts ? shortcuts.innerHTML : "");
    panel.classList.add("is-open");
    input.setAttribute("aria-expanded", "true");
  }

  var predictBindings = [];

  function bindSearchToggles(scope) {
    qsa("[data-search-toggle]", scope).forEach(function (button) {
      if (button.getAttribute("data-chb-bound") === "1") return;
      button.setAttribute("data-chb-bound", "1");
      var searchBox = button.closest("[data-search]");
      if (!searchBox) return;
      button.addEventListener("click", function () {
        searchBox.classList.toggle("is-open");
        button.setAttribute("aria-expanded", String(searchBox.classList.contains("is-open")));
        var input = qs("input[type='search']", searchBox);
        if (!input) return;
        if (searchBox.classList.contains("is-open")) {
          closeShopMenu();
          input.focus();
        } else {
          input.dispatchEvent(new CustomEvent("chb-search-close"));
        }
      });
    });
  }

  function bindPredict(scope) {
    qsa("[data-predict]", scope).forEach(function (form) {
      if (form.getAttribute("data-chb-bound") === "1") return;
      var input = qs("input[type='search']", form);
      var panel = qs("[data-predict-panel]", form.parentNode);
      if (!input || !panel || !form.parentNode) return;
      form.setAttribute("data-chb-bound", "1");
      var pending;
      var suppressTrend = false;
      function closePanel() {
        panel.classList.remove("is-open");
        panel.innerHTML = "";
        input.setAttribute("aria-expanded", "false");
      }
      function showTrend() {
        var data = trendData(form);
        if (!data) {
          var shortcuts = form.parentNode.querySelector("[data-search-shortcuts]");
          if (shortcuts) { panel.innerHTML = shortcuts.innerHTML; panel.classList.add("is-open"); input.setAttribute("aria-expanded", "true"); }
          else closePanel();
          return;
        }
        renderTrend(panel, input, data);
      }
      if (!panel.id) panel.id = "PredictPanel";
      input.setAttribute("aria-expanded", "false");
      input.setAttribute("aria-controls", panel.id);
      input.addEventListener("focus", function () {
        closeShopMenu();
        if (input.value.trim().length === 0 && !suppressTrend) showTrend();
      });
      input.addEventListener("click", function () {
        suppressTrend = false;
        if (input.value.trim().length === 0) showTrend();
      });
      input.addEventListener("chb-search-close", function () {
        clearTimeout(pending);
        suppressTrend = true;
        closePanel();
      });
      input.addEventListener("input", function () {
        var q = input.value.trim();
        clearTimeout(pending);
        if (suppressTrend && q.length === 0) { closePanel(); return; }
        suppressTrend = false;
        if (q.length < 2) {
          if (q.length === 0) showTrend();
          else closePanel();
          return;
        }
        pending = setTimeout(function () {
          fetch(suggestUrl(q))
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (input.value.trim() !== q) return;
              var results = (((data || {}).resources || {}).results) || {};
              var html = "";
              var products = (results.products || []).map(function (item) {
                return resultLink(item.url, item.image, item.title, item.price);
              }).join("");
              var articles = (results.articles || []).map(function (item) {
                return resultLink(item.url, item.image, item.title, "Journal");
              }).join("");
              var collections = (results.collections || []).map(function (item) {
                var image = item.featured_image || item.image || "";
                if (image && typeof image === "object") image = image.url || "";
                return resultLink(item.url, image, item.title, "Range");
              }).join("");
              var pages = (results.pages || []).map(function (item) {
                return resultLink(item.url, "", item.title, "Page");
              }).join("");
              if (products) html += '<p class="predict-label">Products</p>' + products;
              if (collections) html += '<p class="predict-label">Ranges</p>' + collections;
              if (articles) html += '<p class="predict-label">Journal</p>' + articles;
              if (pages) html += '<p class="predict-label">Pages</p>' + pages;
              if (!html) { closePanel(); return; }
              panel.innerHTML = html;
              panel.classList.add("is-open");
              input.setAttribute("aria-expanded", "true");
            })
            .catch(closePanel);
        }, 180);
      });
      input.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          suppressTrend = true;
          closePanel();
        }
        if (event.key === "ArrowDown") {
          var first = qs("a", panel);
          if (first && panel.classList.contains("is-open")) {
            event.preventDefault();
            first.focus();
          }
        }
      });
      panel.addEventListener("keydown", function (event) {
        var links = qsa("a", panel);
        if (!links.length) return;
        var index = links.indexOf(document.activeElement);
        if (event.key === "ArrowDown") {
          event.preventDefault();
          (index < 0 ? links[0] : links[Math.min(index + 1, links.length - 1)]).focus();
        }
        if (event.key === "ArrowUp") {
          event.preventDefault();
          if (index <= 0) input.focus();
          else links[index - 1].focus();
        }
        if (event.key === "Escape") {
          event.preventDefault();
          event.stopPropagation();
          suppressTrend = true;
          closePanel();
          input.focus();
        }
      });
      predictBindings.push({ root: form.parentNode, close: closePanel });
    });
  }

  bindSearchToggles(document);
  bindPredict(document);
  document.addEventListener("click", function (event) {
    predictBindings.forEach(function (entry) {
      if (!entry.root.isConnected) return;
      if (!entry.root.contains(event.target)) entry.close();
    });
  });
  document.addEventListener("shopify:section:load", function (event) {
    bindSearchToggles(event.target);
    bindPredict(event.target);
  });


  var cartDrawer = qs("[data-cart-drawer]");
  var cartLines = qs("[data-cart-lines]");
  var cartCount = qs("[data-cart-count]");

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    return "£" + value;
  }

  function cartEndpoint(name, fallback) {
    var value = window.CHB && window.CHB[name];
    if (!value || value.charAt(0) !== "/") return fallback;
    return value;
  }

  function propHtml(item) {
    var props = item.properties;
    var rows = [];
    if (!props) return "";
    if (Array.isArray(props)) {
      props.forEach(function (row) {
        if (!row || !row.name || String(row.name).charAt(0) === "_") return;
        if (row.value == null || row.value === "") return;
        rows.push([row.name, row.value]);
      });
    } else {
      Object.keys(props).forEach(function (name) {
        if (!name || String(name).charAt(0) === "_") return;
        var value = props[name];
        if (value == null || value === "") return;
        rows.push([name, value]);
      });
    }
    return rows.map(function (row) {
      return '<p class="chb-line__prop"><span>' + esc(row[0]) + ":</span> " + esc(String(row[1])) + "</p>";
    }).join("");
  }

  function lineHtml(item, index, prefix) {
    var href = safeUrl(item.url) || "#";
    var src = safeUrl(item.image || "");
    var key = esc(item.key);
    var title = esc(item.product_title);
    var qtyId = (prefix || "line") + "-qty-" + index;
    var variant = item.variant_title && item.variant_title !== "Default Title"
      ? '<p class="chb-line__variant">' + esc(item.variant_title) + "</p>"
      : "";
    var props = propHtml(item);
    return '<article class="chb-line">' +
      '<a class="chb-line__photo" href="' + esc(href) + '">' +
      (src ? '<img src="' + esc(src) + '" alt="">' : "") + "</a>" +
      '<div class="chb-line__body"><div class="chb-line__top">' +
      '<a class="chb-line__title" href="' + esc(href) + '">' + title + "</a>" +
      '<strong class="chb-line__price">' + money(item.final_line_price) + "</strong></div>" +
      variant +
      props +
      '<div class="chb-line__row"><div class="chb-stepper">' +
      '<button type="button" data-qty-step="-1" data-line="' + key + '" aria-label="Decrease quantity of ' + title + '">&minus;</button>' +
      '<label class="visually-hidden" for="' + qtyId + '">Quantity</label>' +
      '<input id="' + qtyId + '" data-qty="' + key + '" name="updates[]" type="text" inputmode="numeric" value="' + esc(item.quantity) + '">' +
      '<button type="button" data-qty-step="1" data-line="' + key + '" aria-label="Increase quantity of ' + title + '">+</button>' +
      '</div><button type="button" class="chb-line__remove" data-remove="' + key + '">Remove</button></div></div></article>';
  }

  function emptyHtml() {
    var href = safeUrl((window.CHB && window.CHB.allProducts) || "/collections/all");
    return '<div class="chb-bag-empty"><div class="chb-bag-mark" aria-hidden="true">' +
      '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M10 16h28l-2 18H12L10 16z"></path><path d="M18 16v-2.5a6 6 0 0 1 12 0V16"></path></svg></div>' +
      '<p class="eyebrow">Basket</p><h2>Your bag is empty</h2>' +
      '<a class="btn" href="' + esc(href) + '">Continue shopping</a></div>';
  }

  function paintOffer(cart) {
    var offer = cart.chbOffer && cart.chbOffer.quote;
    var text = "";
    var progress = 0;
    var on = false;
    if (offer && offer.units > 0 && window.CHBOffer) {
      text = window.CHBOffer.message(offer);
      progress = offer.progress || 0;
      on = offer.rewards > 0;
    }
    qsa("[data-offer]").forEach(function (box) {
      box.hidden = !text;
      box.classList.toggle("is-on", on);
      var message = qs("[data-offer-message]", box);
      if (message) message.textContent = text;
      var bar = qs("[data-offer-bar]", box);
      if (bar) bar.style.width = progress + "%";
    });
    var note = qs("[data-discount-note]");
    if (note) note.textContent = (cart.chbOffer && cart.chbOffer.note) || "";
  }

  function renderCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.hidden = cart.item_count === 0;
    }
    qsa("[data-cart-count-label]").forEach(function (el) {
      el.textContent = String(cart.item_count);
    });
    var foot = qs("[data-cart-foot]");
    if (foot) foot.hidden = cart.items.length === 0;
    var empty = qs("[data-cart-empty]");
    var filled = qs("[data-cart-filled]");
    if (empty) empty.hidden = cart.item_count !== 0;
    if (filled) filled.hidden = cart.item_count === 0;
    var html = cart.items.length ? cart.items.map(function (item, index) { return lineHtml(item, index, "drawer"); }).join("") : emptyHtml();
    if (cartLines) cartLines.innerHTML = html;
    var pageLines = qs("[data-cart-page-lines]");
    if (pageLines) pageLines.innerHTML = cart.items.length ? cart.items.map(function (item, index) { return lineHtml(item, index, "page"); }).join("") : "";
    var subtotal = money(cart.total_price);
    qsa("[data-cart-subtotal], [data-cart-page-subtotal]").forEach(function (el) {
      el.textContent = subtotal;
    });
    var original = money(cart.original_total_price || cart.total_price);
    qsa("[data-cart-original]").forEach(function (el) { el.textContent = original; });
    qsa("[data-cart-saving]").forEach(function (el) {
      if (cart.total_discount > 0) {
        el.hidden = false;
        el.textContent = "Saving −" + money(cart.total_discount);
      } else {
        el.hidden = true;
        el.textContent = "";
      }
    });
    paintOffer(cart);
    window.CHB = window.CHB || {};
    window.CHB.cartTotal = cart.total_price || 0;
    var gates = qsa("[data-trade-gate]");
    if (gates.length) {
      var min = parseInt(gates[0].getAttribute("data-trade-gate"), 10) || 0;
      var blocked = window.CHB.cartTotal < min;
      gates.forEach(function (btn) { btn.disabled = blocked; });
      qsa("[data-trade-min]").forEach(function (el) { el.hidden = !blocked; });
      qsa("[data-trade-extra]").forEach(function (el) { el.hidden = blocked; });
    }
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var gate = form.querySelector("[data-trade-gate]");
    if (!gate) return;
    var min = parseInt(gate.getAttribute("data-trade-gate"), 10) || 0;
    var total = window.CHB && typeof window.CHB.cartTotal === "number" ? window.CHB.cartTotal : null;
    if (total == null) {
      if (gate.disabled) event.preventDefault();
      return;
    }
    if (total < min) event.preventDefault();
  });

  function settle(cart) {
    var pending = window.CHBOffer ? window.CHBOffer.sync(cart) : Promise.resolve(cart);
    return pending.then(function (next) {
      renderCart(next || cart);
      return next || cart;
    });
  }

  function refreshCart() {
    return fetch(cartEndpoint("cart", "/cart.js"), { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(settle);
  }

  var lastCartFocus = null;

  function setCartOpen(open) {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle("is-open", open);
    cartDrawer.hidden = !open;
    document.documentElement.classList.toggle("cart-open", open);
    qsa("[data-cart-open]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    if (open) {
      var close = qs("[data-cart-close]", cartDrawer);
      if (close) close.focus();
    } else if (lastCartFocus && lastCartFocus.focus) {
      lastCartFocus.focus();
    }
  }

  function openCart() {
    lastCartFocus = document.activeElement;
    setCartOpen(true);
  }

  function closeCart() {
    setCartOpen(false);
  }

  var cartBusy = false;

  function changeCart(id, quantity) {
    if (cartBusy) return Promise.resolve();
    cartBusy = true;
    var error = qs("[data-cart-error]");
    if (error) { error.hidden = true; error.textContent = ""; }
    return fetch(cartEndpoint("cartChange", "/cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: id, quantity: quantity })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok || !body || !Array.isArray(body.items)) throw body;
        return settle(body);
      });
    }).catch(function (err) {
      if (error) {
        error.hidden = false;
        error.textContent = (err && (err.description || err.message)) || "Could not update the basket.";
      }
    }).then(function () { cartBusy = false; });
  }

  if (cartDrawer) {
    qsa("[data-cart-open]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");
      btn.setAttribute("aria-controls", "CartDrawer");
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        refreshCart().then(openCart);
      });
    });
    qsa("[data-cart-close]").forEach(function (btn) {
      btn.addEventListener("click", closeCart);
    });
    cartDrawer.addEventListener("click", function (event) {
      if (event.target === cartDrawer) closeCart();
    });
    cartDrawer.addEventListener("keydown", function (event) {
      if (!cartDrawer.classList.contains("is-open")) return;
      if (event.key === "Escape") { event.preventDefault(); closeCart(); return; }
      if (event.key !== "Tab") return;
      var focusable = qsa("a, button, input, textarea, select", cartDrawer).filter(function (el) {
        return !el.disabled && !el.hidden && el.offsetParent !== null;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  var noteTimer = null;
  var noteSaved = null;
  var notePending = null;
  var noteSeq = 0;
  var firstNote = qs("[data-cart-note]");
  if (firstNote) noteSaved = firstNote.value;

  function saveCartNote(value) {
    if (value === noteSaved || value === notePending) return Promise.resolve();
    var seq = ++noteSeq;
    notePending = value;
    return fetch(cartEndpoint("cartUpdate", "/cart/update.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      keepalive: true,
      body: JSON.stringify({ note: value })
    }).then(function (response) {
      return response.json().then(function (body) {
        if (seq !== noteSeq) return;
        if (!response.ok || !body || !Array.isArray(body.items)) throw body;
        noteSaved = typeof body.note === "string" ? body.note : value;
        notePending = null;
      });
    }).catch(function () {
      if (seq === noteSeq) notePending = null;
    });
  }

  document.addEventListener("input", function (event) {
    var field = event.target.closest("[data-cart-note]");
    if (!field) return;
    qsa("[data-cart-note]").forEach(function (other) {
      if (other !== field) other.value = field.value;
    });
    clearTimeout(noteTimer);
    var value = field.value;
    noteTimer = setTimeout(function () { saveCartNote(value); }, 350);
  });

  document.addEventListener("focusout", function (event) {
    var field = event.target.closest && event.target.closest("[data-cart-note]");
    if (!field) return;
    clearTimeout(noteTimer);
    saveCartNote(field.value);
  });

  document.addEventListener("pointerdown", function (event) {
    var pay = event.target.closest(".chb-checkout, .chb-drawer__checkout, .shopify-payment-button, .chb-extra-pay");
    if (!pay) return;
    var field = qs("[data-cart-note]");
    if (!field) return;
    clearTimeout(noteTimer);
    saveCartNote(field.value);
  }, true);

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-qty]");
    if (!input) return;
    changeCart(input.getAttribute("data-qty"), input.value);
  });
  document.addEventListener("click", function (event) {
    var step = event.target.closest("[data-qty-step]");
    if (step) {
      var key = step.getAttribute("data-line");
      var input = qsa("[data-qty]").filter(function (el) {
        return el.getAttribute("data-qty") === key;
      })[0];
      var qty = input ? parseInt(input.value, 10) || 0 : 0;
      qty = Math.max(0, qty + (parseInt(step.getAttribute("data-qty-step"), 10) || 0));
      changeCart(key, qty);
      return;
    }
    var remove = event.target.closest("[data-remove]");
    if (remove) changeCart(remove.getAttribute("data-remove"), 0);
    var apply = event.target.closest("[data-discount-apply]");
    if (!apply) return;
    var field = qs("[data-discount-input]");
    var code = field ? field.value.trim() : "";
    var note = qs("[data-discount-note]");
    if (window.CHBOffer && window.CHBOffer.current && window.CHBOffer.current.rewards > 0) {
      if (note) note.textContent = window.CHBOffer.current.blocked || "";
      return;
    }
    if (!code) return;
    fetch(cartEndpoint("cartUpdate", "/cart/update.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ discount: code })
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok || !body || !Array.isArray(body.items)) throw body;
        var applied = (body.discount_codes || []).some(function (row) {
          return row && String(row.code || "").toLowerCase() === code.toLowerCase() && row.applicable;
        });
        if (!applied) {
          if (note) note.textContent = "That code could not be applied.";
          return settle(body);
        }
        if (field) field.value = "";
        if (note) note.textContent = "Code applied.";
        return settle(body);
      });
    }).catch(function () {
      if (note) note.textContent = "That code could not be applied.";
    });
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var topic = form.querySelector("[data-contact-topic]");
    var body = form.querySelector("[name='contact[body]']");
    if (!topic || !body || !topic.value) return;
    var line = "This message is about: " + topic.value;
    if (body.value.indexOf(line) !== 0) body.value = line + "\n\n" + body.value;
  }, true);

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    if (cartDrawer && cartDrawer.classList.contains("is-open")) closeCart();
    var panel = qs("[data-predict-panel].is-open");
    if (panel) {
      panel.classList.remove("is-open");
      panel.innerHTML = "";
      var searchInput = qs("[data-predict] input[type='search']");
      if (searchInput) searchInput.setAttribute("aria-expanded", "false");
    }
  });

  qsa("[data-product-form]").forEach(function (form) {
    form.addEventListener("submit", function (event) {
      var trio = form.querySelector("[data-trio-picks]");
      if (trio) {
        var missing = null;
        qsa("[data-trio-soap]", trio).forEach(function (select) {
          if (!select.value && !missing) missing = select;
        });
        if (missing) {
          event.preventDefault();
          var note = qs("[data-product-error]", form);
          if (note) note.textContent = "Choose Soap 1, Soap 2 and Soap 3 before adding the set.";
          missing.focus();
          return;
        }
      }
      if (!document.body.dataset.drawerCart) return;
      var submitter = event.submitter;
      if (submitter && submitter.closest && submitter.closest(".shopify-payment-button")) return;
      event.preventDefault();
      var data = new FormData(form);
      fetch(cartEndpoint("cartAdd", "/cart/add.js"), {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return refreshCart();
        })
        .then(openCart)
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || "Could not add that product.";
          var note = qs("[data-product-error]", form);
          if (note) note.textContent = msg;
        });
    });
  });

  qsa("[data-gallery]").forEach(function (gallery) {
    var main = qs(".gallery-main img", gallery);
    qsa("[data-thumb]", gallery).forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!main) return;
        main.removeAttribute("srcset");
        main.removeAttribute("sizes");
        main.src = thumb.getAttribute("data-full");
        main.alt = thumb.getAttribute("data-alt") || "";
      });
    });
  });

  refreshCart().catch(function () {});
})();
